import { Outlet } from 'react-router';

import { BrandMark } from './BrandMark';

export function AppLayout() {
  return (
    <div className="app-shell">
      <header className="app-header">
        <BrandMark />
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <span>
          Powered by <strong>PlayerUp</strong> · Sports team management
        </span>
      </footer>
    </div>
  );
}
